import { useFlags } from "./launch_darkly_helper";

/**
 * The bigBimViewerPerformance LaunchDarkly flag (key big-bim-viewer-performance): HMA-1795's work on big floors
 * (keeping the viewer loaded, caching in the browser, leaner element data, faster selection and coloring).
 * Off, everything behaves as it did before that work. The previous code paths sit beside the new ones, marked
 * with this flag, so they can be deleted together once it's fully rolled out.
 *
 * Read when the work runs, so it follows the flag as LaunchDarkly delivers it; toggle it, then reload the page.
 */
let overrideForTests: boolean | null = null;

/** For code outside React (reducers, selectors, viewer services), which can't use useFlags(). */
export function isBigBimViewerPerformanceOn(): boolean {
  return overrideForTests ?? !!window.Avvir?.featureFlags?.flagsReadOnly?.bigBimViewerPerformance;
}

export function useBigBimViewerPerformance(): boolean {
  const { bigBimViewerPerformance } = useFlags();
  return overrideForTests ?? !!bigBimViewerPerformance;
}

/** null goes back to reading the flag. */
export function setBigBimViewerPerformanceForTests(on: boolean | null) {
  overrideForTests = on;
}

/** Picks between a selector (or any function) and the one it replaced, on each call. */
export function withBigBimViewerPerformance<Fn extends (...args: any[]) => any>(whenOn: Fn, whenOff: (...args: Parameters<Fn>) => ReturnType<Fn>): (...args: Parameters<Fn>) => ReturnType<Fn> {
  return (...args) => isBigBimViewerPerformanceOn() ? whenOn(...args) : whenOff(...args);
}
